export default {
  BusinessStockDistributionRatioViewForm: {
    basicInformation: 'Account Information',
    supportName: 'Supply Warehouse Name:',
    supportTypeMeaning: 'Supply Warehouse Type:',
    supportCode: 'Supply Warehouse Code:',
    receiveName: 'Receiving Warehouse Name:',
    receiveTypeMeaning: 'Supply Warehouse Type:',
    receiveCode: 'Supply Warehouse Code:',
    commodityDetails: 'Product Details',
    selectGoods: 'Select Supply Warehouse Product',
    operationLog: 'Operation Log',
    selectProduct: 'Select Product',
    spuNameText: 'Please enter the product name',
    spuCodeText: 'Please enter the product code',
    skuCodeText: 'Please enter the SKU code',
    categoryIdText: 'Please select a category',
    msgWarning: 'Product cannot be empty',
    confirmText: 'This operation will lose temporarily added data, continue?',

    table: {
      categoryName: 'Product Category',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      warehouseStructuralQty: 'Warehouse Structure Ratio',
      qty: 'Product Bin Ratio'
    }
  }
};
